module.exports = __webpack_public_path__ + "static/media/ugo_tex.b444a66f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ugo/ugo_tex.png
// module id = 133
// module chunks = 0